import React from 'react';
import { useStaticAsset } from '@leagueplatform/asset-config';
import {
  Box,
  HeadingText,
  GDSStyleObject,
  StackLayout,
  Button,
  Modal,
} from '@leagueplatform/genesis-core';

import { SHARED_LIBRARY_ASSET_KEYS } from '../../types/shared-library.types';

export function SuccessModal(props: any) {
  const { open, onClose, heading, description, btnText } = props;

  return (
    <Box>
      <Modal.Root open={open} onOpenChange={onClose}>
        <Modal.Content
          data-testid="success-modal"
          showCloseButton={false}
          css={
            {
              borderRadius: '12px',
              background: '#fff',
              zIndex: 9999,
              '.GDS-modal': {
                borderRadius: '$none',
                zIndex: 9999,
                margin: '0px',
                // height: ['Firefox'].includes(browser) ? '100vh' : '',
                // maxHeight: ['Firefox'].includes(browser) ? '550px' : 'initial',
              },
              '.GDS-modal-overlay': {
                zIndex: 9999,
              },
            } as GDSStyleObject
          }
          width={{
            '@initial': 'standard',
            '@laptop': '38%',
            '@mobileLandscape': '50%',
            '@tablet': '50%',
          }}
          onInteractOutside={(e) => e.preventDefault()}
        >
          <StackLayout
            css={{
              textAlign: 'center',
              alignItems: 'center',
              zIndex: 9999,
            }}
          >
            <Box
              css={
                {
                  marginTop: '$two',
                  backgroundColor: 'White',
                  zIndex: 9999,
                } as GDSStyleObject
              }
            >
              <img
                style={{ cursor: 'pointer' }}
                src={
                  useStaticAsset(
                    SHARED_LIBRARY_ASSET_KEYS.SUCCESS_ICON,
                  ) as string
                }
                alt="right arrow icon"
                width="55px"
              />
              <HeadingText
                data-testid="success-heading"
                level="1"
                size={{
                  '@initial': 'xxl',
                  '@mobile': 'xl',
                }}
                css={
                  {
                    paddingTop: '$one',
                  } as GDSStyleObject
                }
              >
                {heading}
              </HeadingText>
              <HeadingText
                data-testid="success-description"
                css={
                  {
                    margin: '$two $none $one $none',
                    maxWidth: '390px',
                    lineHeight: '24px',
                    fontSize: '16px',
                    fontWeight: '400',
                  } as GDSStyleObject
                }
                level="3"
                size={{
                  '@initial': 'lg',
                  '@mobile': 'lg',
                }}
              >
                {description}
              </HeadingText>
              <Button
                size="small"
                data-testid="close-btn"
                css={
                  {
                    color: '#0074C9',
                    cursor: 'pointer',
                    fontWeight: '700',
                    fontSize: 16,
                    padding: '$oneAndHalf',
                    // outline: 'none !important',
                    background: 'none',
                    '&:hover,&:active,&:focus': {
                      background: 'none',
                    },
                  } as GDSStyleObject
                }
                onClick={onClose}
              >
                {btnText}
              </Button>
            </Box>
          </StackLayout>
        </Modal.Content>
      </Modal.Root>
    </Box>
  );
}
